import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'
import { Iconfont } from 'vuetify/types/services/icons'
import i18n from './i18n'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: "mdi" as Iconfont,
  },
  lang: {
    t: (key: VueI18n.Path, ...params: Array<string | number>) => i18n.t(key, params) as string,
  },
  theme: {
    themes: {
      light: {
        primary: '#d12a2f',
        secondary: '#fac3b9',
        accent: colors.shades.black,
        error: colors.red.accent3,
      },
      dark: {
        primary: '#d12a2f',
      },
    },
  },
}

export default new Vuetify(opts)